const InformationSecurityPolicy = () => {
  return (
    <div className="overflow-hidden">
      <section className="relative py-24 hero-gradient mesh-gradient">
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold font-['Outfit'] tracking-tighter mb-6">
              Information Security Policy
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Jnan Innovative IT Solutions is committed to protecting customer and business information from unauthorized access, disclosure, alteration, or destruction.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-slate max-w-none">
            <p><strong>Effective Date:</strong> 4/19/2026</p>

            <h2>1. Introduction</h2>
            <p>
              Jnan Innovative IT Solutions is committed to protecting customer and business information from unauthorized access, disclosure, alteration, or destruction.
            </p>
            <br />

            <h2>2. Security Controls</h2>
            <ul>
              <li>Role-based access controls are implemented.</li>
              <li>Least-privilege permissions are used for systems that handle customer, business, or Amazon SP-API data.</li>
              <li>Production access is restricted to authorized personnel.</li>
              <li>Secure authentication is required for all systems.</li>
              <li>Development, testing, and production environments are separated.</li>
              <li>HTTPS/TLS encryption is used for data in transit.</li>
              <li>PII at rest is encrypted using AES-128/RSA-2048 or stronger, with AES-256 preferred where supported.</li>
              <li>Security logs are maintained and reviewed periodically.</li>
            </ul>
            <br />

            <h2>3. Credential Management</h2>
            <p>
              Credentials, API secrets, Amazon SP-API tokens, database passwords, and encryption secrets are stored securely and access is limited to authorized personnel. Secrets are not hardcoded in source code or stored in plaintext.
            </p>
            <br />

            <h2>4. Key Management</h2>
            <p>
              We maintain key management controls covering key generation, secure storage, access control, rotation, revocation, and emergency replacement after suspected compromise. Key access is restricted by least privilege and reviewed periodically.
            </p>
            <br />

            <h2>5. Vulnerability Management</h2>
            <p>
              Systems that store, process, or transmit Amazon information are included in vulnerability management. Vulnerability scans are conducted at least every 30 days, code and dependency scans are performed before production releases where applicable, and penetration testing is performed at least every 365 days. Critical findings are remediated within 7 days and high-risk findings within 30 days.
            </p>
            <br />

            <h2>6. Logging and Monitoring</h2>
            <p>
              Audit logs are maintained for authentication, authorization, administrative access, API activity, data access, data changes, configuration changes, and system errors. Logs are protected against unauthorized access or tampering, reviewed in real time where configured or at least bi-weekly, and retained for a minimum of 12 months. Logs are designed to avoid storing PII unless legally required.
            </p>
            <br />

            <h2>7. Incident Management</h2>
            <p>
              Security incidents are investigated promptly and corrective actions are implemented to prevent recurrence.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InformationSecurityPolicy;
